import { render, staticRenderFns } from "./MyOrderList.vue?vue&type=template&id=6ddd1eaa&"
import script from "./MyOrderList.vue?vue&type=script&lang=js&"
export * from "./MyOrderList.vue?vue&type=script&lang=js&"
import style0 from "./MyOrderList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports